"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.build_data = void 0;
exports.build_data = { "build_version": "3.3.2.1", "build_date": "2024-08-19T09:10:00.587Z", "build_branch": "development", "build_commit": "f62593f44e258bd54ea463ae7f2901de52bd7b3e" };
//# sourceMappingURL=build_data.js.map